import { lazy } from "react";

const Taxes = lazy(() => import("./Taxes"));

const TaxesRoutes = [
  {
    path: "/taxes/tax",
    element: <Taxes />,
  },
  
 
];

export default TaxesRoutes;
